import { createElement } from "react";
import { realRainMarkSources as REALRAIN_MARKS } from "./assets/marks.js";

export function RealRainMark({ className = "", title = "RealRain", treatment = "small" }) {
  return createElement(
    "span",
    {
      className: `rrui-mark rrui-mark--${treatment} ${className}`.trim(),
      role: "img",
      "aria-label": title,
    },
    createElement("img", {
      className: "rrui-mark__image rrui-mark__image--small",
      src: REALRAIN_MARKS.small,
      alt: "",
      draggable: false,
      "aria-hidden": "true",
    }),
    createElement("img", {
      className: "rrui-mark__image rrui-mark__image--layered",
      src: REALRAIN_MARKS.layered,
      alt: "",
      draggable: false,
      "aria-hidden": "true",
    }),
    createElement("img", {
      className: "rrui-mark__image rrui-mark__image--reverse",
      src: REALRAIN_MARKS.reverse,
      alt: "",
      draggable: false,
      "aria-hidden": "true",
    }),
  );
}
